export const admission = "https://admission.kpru.ac.th/admission2017";
// export const admission = "https://git.kpru.ac.th/admission2017";
